var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgProject16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 14.6C11.6451 14.6 14.6 11.6451 14.6 8.00002C14.6 4.35494 11.6451 1.40002 7.99999 1.40002C4.35491 1.40002 1.39999 4.35494 1.39999 8.00002C1.39999 11.6451 4.35491 14.6 7.99999 14.6Z",
    fill: "#F4F4F4",
    stroke: "#F4F4F4",
    strokeWidth: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2171_88372)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.5H8C7.72397 4.50028 7.50028 4.72397 7.5 5V7.5H5C4.72397 7.50028 4.50028 7.72397 4.5 8V11.5H11.5V5C11.4997 4.72397 11.276 4.50028 11 4.5ZM6.25 11V9.25H7.25V11H6.25ZM11 11H7.75V9C7.75 8.86193 7.63807 8.75 7.5 8.75H6C5.86193 8.75 5.75 8.86193 5.75 9V11H5V8H8V5H11V11ZM8.5 6H9V6.5H8.5V6ZM10 6H10.5V6.5H10V6ZM8.5 7.5H9V8H8.5V7.5ZM10 7.5H10.5V8H10V7.5ZM8.5 9H9V9.5H8.5V9ZM10 9H10.5V9.5H10V9Z",
    fill: "#CACACA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2171_88372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(4.5 4.5)"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgProject16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/project-16.1e9a29718baf1b011e794e0b2d046809.svg";